import styled from "styled-components";

export const Wrapper = styled.div`
  background: rgb(0, 153, 255);
  margin-bottom: 10rem;
  padding-bottom: 0.5rem;
`;
